import React, { Fragment } from 'react';

export default {
  title: <Fragment>Schwarz-Rot</Fragment>,
  duration: 'November 2005 - Oktober 2009',
  startDate: new Date(2005, 10, 21),
  endDate: new Date(2009, 9, 27),
  description: 'Juniorpartner',
  description_long: 'Mit der Wahl von Angela Merkel zur ersten Bundeskanzlerin beginnt am 22. November eine neue politische Zeitrechnung. Die SPD wird Juniorpartner in der großen Koalition. Die begonnenen Hartz-Reformen werden fortgesetzt. In den Umfragen geraten die Sozialdemokraten bis zum Ende der Wahlperiode in einen Abwärtssog.',
  items: [{
    milestone: true,
    coords: {
      x: new Date(2006, 4, 6),
      y: 28.2
    },
    coordsMobile: {
      x: new Date(2006, 4, 6),
      y: 26
    },
    kicker: '14. Mai 2006',
    title: (<h3>Kurt Beck <em>(847 Tage)</em></h3>),
    text:
      <p>
        <span className="media">
          <img src="images/chronik/05-2006-beck.jpg"/>
          <span className="media-sub clearfix">
            <span className="media-caption"></span>
            <span className="media-credit">picture-alliance/Sven Simon</span>
          </span>
        </span>
      Nach Platzecks Abgang rückt sein Stellvertreter Kurt Beck auf den Chefposten vor. 
      Der “Landesvater” von Rheinland-Pfalz will Korrekturen an der Agenda 2010 durchsetzen und wird später als Kanzlerkandidat gehandelt. 
      Er scheitert aber in einem innerparteilichen Machtkampf. 
      Schließlich fühlt sich Beck auch als SPD-Chef übergangen und wirft im September 2008 das Handtuch.
      </p>,
    additional: (<ul>
          <li><strong>Umfragehoch: </strong>33&nbsp;Prozent (Infratest dimap) am 5. Oktober 2006</li>
          <li><strong>Umfragetief: </strong>20&nbsp;Prozent (Forsa) am 4. Juni 2006</li>
        </ul>)
  }, {
    milestone: false,
    coords: {
      x: new Date(2008, 8, 6),
      y: 21
    },
    coordsMobile: {
      x: new Date(2008, 8, 6),
      y: 17
    },
    kicker: '7. September 2008',
    title: 'Frank-Walter Steinmeier übernimmt kommissarisch den Vorsitz',
    text:
      <p>
      Nach Becks plötzlichem Rücktritt verwaltet Frank-Walter Steinmeier den Parteivorsitz für 41 Tage kommissarisch. 
      Der Außenminister und Vizekanzler wird auch Kanzlerkandidat der SPD für die Bundestagswahl 2009.
      </p>
  }, {
    milestone: true,
    coords: {
      x: new Date(2008, 9, 17),
      y: 23
    },
    coordsMobile: {
      x: new Date(2009, 9, 17),
      y: 18.3
    },

    kicker: '18. Oktober 2008',
    title: (<h3>Franz Müntefering <em>(391 Tage)</em></h3>),
    text:
      <p>
        <span className="media">
          <img src="images/chronik/07-2008-muentefering.jpg"/>
          <span className="media-sub clearfix">
            <span className="media-caption"></span>
            <span className="media-credit">dpa/picture alliance</span>
          </span>
        </span>
     Nach einem Jahr Pause zeigt sich Müntefering wieder auf der großen politischen Bühne - und wird noch einmal Parteichef. 
     Er hatte sich im November 2007 zur Pflege seiner schwerkranken Frau zurückgezogen und seine Ämter als Vizekanzler und Arbeitsminister niedergelegt. 
     Sein Comeback soll nicht allzu lange andauern: Nach der Niederlage bei der Bundestagswahl 2009 wird er zurücktreten.
      </p>,
      additional: (<ul>
          <li><strong>Umfragehoch: </strong>28&nbsp;Prozent (Emnid) am 21. April 2009</li>
          <li><strong>Umfragetief: </strong>20&nbsp;Prozent (Forsa) am 5. August 2009</li>
        </ul>)
  }, {
    milestone: false,
    coords: {
      x: new Date(2009, 8, 26),
      y: 24.5
    },
    coordsMobile: {
      x: new Date(2009, 8, 26),
      y: 21
    },

    kicker: '27. September 2009',
    title: 'SPD verliert zweistellig bei der Bundestagswahl',
    text:
    <p>
    In den Umfragen ist die SPD längst unter 30 Prozent gerutscht. Bei der Bundestagswahl erlebt die Partei mit ihrem Spitzenkandidaten Steinmeier ein Debakel: 
    Mit 23 Prozent (-11,2) erreicht sie das bis dahin schlechteste Ergebnis in der SPD-Geschichte. Für Union und FDP reicht es zu einer Mehrheit.
    </p>
  }]
};
